import { InsightSVG } from "./InsightSVG";
export default InsightSVG;
